import GameObject from '../../../GameObject/GameObject';
import AnimationClip, { AnimationClipEvent } from '../AnimationClip';
import BaseCard from '../../../Prototype/Level/Card/BaseCard';
import TransformComponent from '../../../Component/Transform';
import { StartAnimation } from '../AnimationHelper';
import Renderable from '../../../Component/Renderable';
import { delay } from '../../../Utility/Task/TaskQueue';
import CardSystem from '../../Card/CardSystem';

interface ICardPlusFiveMeta {
    system: CardSystem;
    targetCards: BaseCard[];
    stackContainer: GameObject;
}

export class CardPlusFive extends AnimationClip {
    public *execute(
        animator: GameObject,
        meta: ICardPlusFiveMeta
    ): IterableIterator<number> {
        // Set position of all cards first to fix stack counter.
        for (let card of meta.targetCards) {
            meta.stackContainer.addChild(card);
            const transform = card.getComponent(TransformComponent);
            transform.position.set(-200, 200);
        }

        for (let card of meta.targetCards) {
            const transform = card.getComponent(TransformComponent);
            card.getComponent(Renderable).visible = true;
            StartAnimation(card, 'CardSlide', {
                x: -150,
                y: 0,
            }).on(AnimationClipEvent.COMPLETE, () => {
                transform.position.set(-150, 0);
                transform.rotation = 0;
                this.emit('PlusFiveCardAdded', card);
            });

            // Delay between each card sliding in.
            yield* delay(100);
        }

        yield* delay(200);
    }
}
